import { api, catchErrorHandler } from "utils/api";

export const confirmPhoneNumber = async (phoneNumber) => {
  try {
    const { data } = await api.post(`/mobile/verify-limit-manager`, {
      phoneNumber: phoneNumber,
    });
    return data;
  } catch (error) {
    return catchErrorHandler(error, "confirmPhoneNumber");
  }
};

export const signUp = async ({
  phoneNumber,
  password,
  name,
  birthYear,
  sex,
  useTermYN,
  privacyYN,
  marketingYN,
  appToken,
  deviceOsCode,
  deviceName,
  deviceMacId,
}) => {
  try {
    const { data } = await api.post(`/mobile/sign-up`, {
      phoneNumber: phoneNumber,
      passCode: password,
      name: name,
      birthYear: birthYear,
      gender: sex,
      passAuthYN: "Y",
      useTermYN,
      privacyYN,
      marketingYN,
      appToken,
      deviceOsCode,
      deviceName,
      deviceMacId,
    });

    // 헤더에 전역으로 Authorization 적용
    api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
    // localstorage에 토큰 저장
    window.localStorage.setItem("accessToken", data.accessToken);
    window.localStorage.setItem(
      "seqManagerMobileDevice",
      data.seqManagerMobileDevice
    );

    return data;
  } catch (error) {
    return catchErrorHandler(error);
  }
};
